export const TH_LIST_METRICS = [
	{ Name: 'TEMPERATURE', Value: 'temperature' },
	{ Name: 'SETPOINT', Value: 'setpoint' },
	{ Name: 'HUMIDITY', Value: 'humidity' },
	{ Name: 'EXT_TEMPERATURE', Value: 'ext_temperature' },
	{ Name: 'EXT_HUMIDITY', Value: 'ext_humidity' },
	{ Name: 'RELAY_STATUS', Value: 'relay_status' },
];

export class LogThExport {
	Url?: string;
	FileType?: string;

	constructor() {
		this.Url = '';
		this.FileType = '';
	}
}

export const BnB_MINFWVER_THONE230: string = '1.1.3.0';

export const TH_MANUAL_TEMP_MIN_SETPOINT: number = 3; // 3.0 degrees
export const TH_MANUAL_TEMP_MAX_SETPOINT: number = 35; // 35.0 degrees
export const TH_MANUAL_TEMP_STEP: number = 0.1; // 0.1 degrees

export const TH_MIN_VALUE_DELTA: number = 0; // 0.0 degrees
export const TH_MAX_VALUE_DELTA: number = 3; // 3.0 degrees
export const TH_DELTA_STEPS: number = 0.5; // 0.5 degrees

export const TH_BB_TEMP_MIN_SETPOINT: number = 3; // 3.0 degrees
export const TH_BB_TEMP_MAX_SETPOINT: number = 35; // 35.0 degrees
export const TH_BB_TEMP_STEP: number = 0.1; // 0.1 degrees

export const TH_QE_COURTESY_TIME_MIN_VALUE: number = 0; // 0 min
export const TH_QE_COURTESY_TIME_MAX_VALUE: number = 180; // 180 min
export const TH_QE_COURTESY_TIME_STEPS: number = 15; // 15 min

export const TH_QE_STANDBY_TEMP_MIN_SETPOINT: number = 3; // 3.0 degrees
export const TH_QE_STANDBY_TEMP_MAX_SETPOINT: number = 35; // 35.0 degrees
export const TH_QE_STANDBY_TEMP_STEP: number = 0.1; // 0.1 degrees

export enum SliderTemperatureSetPoint {
	MANUAL_TEMP = 0,
	BnB_MANUAL_TEMP = 1,
	QnE_STANDBY_TEMP = 2,
	BnB_DELTA = 3, // will be used when will be have only one range slider
	BnB_DELTA_POSITIVE = 4, // will be removed
	BnB_DELTA_NEGATIVE = 5, // will be removed
}

export enum ButtonsTemperatureSetPoint {
	DECREASE = -1,
	INCREASE = +1,
}